import React from 'react';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faClose} from '@fortawesome/free-solid-svg-icons/faClose';
import {OUTGOING_ACTION, snippetService} from '../../services/snippet.service';
import {getFromStore, StorePath} from '../../services/store.service';

const Header = () => {
    const dealerInfo = getFromStore(StorePath.DEALER_INFO) as { name: string | null };

    const close = (): void => {
        snippetService.sendMessage({action: OUTGOING_ACTION.HIDE});
    };

    return (
            <div className="border border-primary bg-primary flex items-center text-white rounded-t py-[4px] pl-[16px] pr-[4px]">
                <div className="grow">
                    <div className="font-medium">{dealerInfo?.name}</div>
                </div>
                <button type="button"
                        className="w-10 h-10 flex-none font-bold rounded-full my-1"
                        onClick={close}>
                    <FontAwesomeIcon icon={faClose} size="lg"/>
                </button>
            </div>
    );
};

export default Header;
